import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import UserService from '../../services/userService';
import { ChangePasswordModel } from '../../models/user/changePasswordModel';
import AuthService from '../../services/authService';


interface IProps {
    onSuccessPasswordChange: any,
    cancelClick: any,
    isVisible: boolean,
}

interface IState {
    currentPassword: string;
    newPassword: string;
    newPassword2: string;
    isLoading: boolean;
    validationMessage: string;
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '50% !important'
            },
            paperFullWidth: {
                width: '70%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class ChangePasswordDialog extends React.Component<IProps, IState> {
    snackbar: any;
    authService = new AuthService();
    userService = new UserService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            currentPassword: '',
            newPassword: '',
            newPassword2: '',
            validationMessage: '',
            isLoading: false
        };
    }

    componentDidMount() {

    }

    isCahangePasswordFormIsValid = () => {
        this.setState({ validationMessage: '' });
        const { currentPassword, newPassword, newPassword2 } = this.state;
        let message = '';

        if (!currentPassword) {
            message += Translate('FillCurrentPassword') + '<br />';
        }

        if (!newPassword) {
            message += Translate('FillNewPassword') + '<br />';
        }

        if (!newPassword2) {
            message += Translate('Please repeat password') + '<br />';
        }

        if (newPassword && newPassword2) {
            if (newPassword !== newPassword2)
                message += Translate('Passwords dont match') + '<br />';
        }


        this.setState({
            validationMessage: message
        });

        return message === '';
    }

    handleSaveButton = (e) => {
        if (!this.isCahangePasswordFormIsValid()) return;

        const { currentPassword, newPassword } = this.state;

        let changePasswordModel = new ChangePasswordModel();
        changePasswordModel.userId = this.authService.getUserId();
        changePasswordModel.currentPassword = currentPassword;
        changePasswordModel.newPassword = newPassword;

        this.setState({
            isLoading: true
        });

        this.userService.changePassword(changePasswordModel).then(
            (result) => {
                if (result) {
                    this.setState({
                        isLoading: false,
                        currentPassword: '',
                        newPassword: '',
                        newPassword2: ''
                    });
                    this.props.onSuccessPasswordChange();
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    validationMessage: error.message
                })
            });
    }

    handleCancelButton = () => {
        this.setState({
            currentPassword: '',
            newPassword: '',
            newPassword2: ''
        })
        this.props.cancelClick();
    }

    public render() {

        const { currentPassword, newPassword, newPassword2, validationMessage, isLoading } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isVisible}
                    onClose={this.handleCancelButton}
                    fullWidth
                    disableBackdropClick={true}
                >
                    <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Change password')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}
                        <Snackbar ref={(el) => this.snackbar = el} />
                        <div>
                            {validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <TextField
                                name="name"
                                label={Translate('CurrentPassword')}
                                type="password"
                                onChange={(e) => this.setState({ currentPassword: e.target['value'] })}
                                value={currentPassword ? currentPassword : ''}
                                style={{ width: 50 + '%' }}
                            />

                            <TextField
                                name="name"
                                label={Translate('NewPassword')}
                                type="password"
                                onChange={(e) => this.setState({ newPassword: e.target['value'] })}
                                value={newPassword ? newPassword : ''}
                                style={{ width: 50 + '%', marginTop: 10 }}
                            />

                            <TextField
                                name="name"
                                label={Translate('RepeatPassword')}
                                type="password"
                                onChange={(e) => this.setState({ newPassword2: e.target['value'] })}
                                value={newPassword2 ? newPassword2 : ''}
                                style={{ width: 50 + '%', marginTop: 10, marginBottom: 10 }}
                            />

                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained">
                                {Translate("Save")}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog >
            </MuiThemeProvider>
        )
    }
}

export default ChangePasswordDialog;